import { Box, Breadcrumbs, CircularProgress, Link, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchGroupDetails } from '../../../api/kindergarten.api';
import { GeneralStatusEnum, KindergartenDetailsTabs } from '../../../common/enums/common.enum';
import { GroupDto } from '../../../common/interfaces/kindergarten.interface';
import GroupEventsTab from '../../GroupDetails/components/GroupEventsTab';
import { createNotification } from '../../../utilities/helper/notification.helper';
import { MESSAGE_TYPE } from '../../../common/constants/common.constants';

const GroupEventConfiguration = () => {
  const { groupId, kindergartenId, kindergartenName, locationName } = useParams<{
    groupId: string;
    kindergartenId: string;
    kindergartenName: string;
    locationName: string;
  }>();

  const [group, setGroup] = useState<GroupDto | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (groupId && kindergartenId) {
      getGroupDetails(kindergartenId, groupId);
    }
  }, [groupId, kindergartenId]);

  const getGroupDetails = async (kindergartenId: string, groupId: string) => {
    try {
      if (!kindergartenId || !groupId) {
        return;
      }
      const response = await fetchGroupDetails(kindergartenId, groupId);
      if (!response.results) return;
      setGroup(response.results);
    } catch (error) {
      createNotification(MESSAGE_TYPE.ERROR, 'Failed to get group details');
    }
  };
  if (!group) {
    return (
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', p: 7 }}>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
        <Link color="text.secondary" underline="hover" onClick={() => navigate('/')} sx={{ cursor: 'pointer' }}>
          Kindergartens
        </Link>
        {kindergartenName && kindergartenId && (
          <Link
            color="text.secondary"
            underline="hover"
            onClick={() => navigate(`/${kindergartenId}/details?tab=${KindergartenDetailsTabs.EventConfiguration}`)}
            sx={{ cursor: 'pointer' }}
          >
            {decodeURIComponent(kindergartenName)}
          </Link>
        )}
        <Typography>{group.name}</Typography>
      </Breadcrumbs>

      <Box>
        <Typography variant="h1">{group.name}</Typography>

        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 400,
            color: 'text.primary',
            fontFamily: 'Poppins',
            lineHeight: 'normal'
          }}
        >
          {decodeURIComponent(locationName ?? '')}
        </Typography>
      </Box>

      <Box>{groupId && <GroupEventsTab groupId={groupId} isGroupActive={group.status === GeneralStatusEnum.ACTIVE} />}</Box>
    </Box>
  );
};

export default GroupEventConfiguration;
